import React from 'react';

const Loader = ({ visible, description }) => {
  if (!visible) return null;

  return (
    <div id="overlay-loader" className="overlay">
      <div className="overlay-background"></div>
      <div id="loader" className="loader"></div>
      {description && (
      <div id="loaderDesc" className="loaderDesc">
        {description}
      </div>
      )}
    </div>
  );
};

export default Loader;
